import React from "react"

const Audio = ({ url = "", controls = true, type = "audio/mpeg", title = "", className = "", ...props }) => {
	return (
		<audio title={title} controls={controls} className={`${className} audio`} {...props}>
			<source src={url} type={type} />
		</audio>
	)
}

export default Audio
